const t = {
  title: {
    type: String,
    default: ""
  },
  dialogClass: {
    type: String,
    default: ""
  },
  customClass: {
    type: String,
    default: ""
  },
  showClose: {
    type: Boolean,
    default: !0
  },
  draggable: {
    type: Boolean,
    default: !1
  }
}, e = {
  close: () => !0
};
export {
  e as dialogContentEmits,
  t as dialogContentProps
};
